<a *ngIf="show" href="https://account.teuteuf.fr/premium-sign-up" title="Teuteuf Games - Holiday Sale!"
  className="hover:opacity-90 flex w-full lg:w-[664px] justify-center items-center" target="_blank" rel="noreferrer">
  <img className="lazy pointer-events-all" alt="Teuteuf Games - Holiday Sale!" loading="lazy"
    src="./assets/holiday-sale.svg" width="664" />
</a>